import { LoadingSpinner } from './loading-spinner.tsx'

export const LoadingOverlay = () => (
  <div className="px-auto relative mx-auto flex w-full justify-center">
    <LoadingSpinner className="text-primary-blue fixed mx-auto mt-44 flex h-20 w-full items-center justify-center" />
  </div>
)
